<div class="menu-placeholder bg-primary" [class.menu-compact]="compact" [class.menu-open]="mobileMenuShowing">
    <div class="menu-floating">
        <ul class="menu-wrapper d-flex align-items-stretch">
            <li class="d-flex align-items-center justify-content-center flex-grow-1 bg-primary">
                <a class="logo" routerLink="/">
                    <img class="img-fluid" src="/assets/images/logo-stelmach.svg" alt="Stelmach" />
                </a>
            </li>
            <li class="toggle-btn" role="button" tabindex="0" (click)="toggleMenu()" (keyup.enter)="toggleMenu()">
                <app-menu-hamburger [open]="mobileMenuShowing"></app-menu-hamburger>
            </li>
        </ul>
        @if (mobileMenuShowing) {
            <div class="sub-menu bg-white position-relative">
                <div class="pb-8 h-100 overflow-auto d-flex flex-column">
                    <ul class="sub-menu-list mb-10" [class.menu-main-page]="isMainPage">
                        @for (item of menuItems; track item; let last = $last) {
                            <li class="py-4 text-center border-b border-gray-100">
                                <a
                                    (click)="itemClick()"
                                    [routerLink]="item.url | localize"
                                    routerLinkActive="active"
                                    class="font-secondary text-hover-primary fs-14 fw-600"
                                >
                                    {{ item.name | translate }}
                                </a>
                            </li>
                        }
                        <li class="py-4">
                            <div class="d-flex align-items-center justify-content-center">
                                <app-search></app-search>
                            </div>
                        </li>
                    </ul>
                    <div class="mt-auto px-4">
                        <app-menu-languages></app-menu-languages>
                    </div>
                </div>
            </div>
        }
    </div>
</div>
